module.exports = __webpack_public_path__ + "static/media/image.1dc12c3c.png";